import { render, staticRenderFns } from "./create_with_label.vue?vue&type=template&id=e03d050c"
import script from "./create_with_label.vue?vue&type=script&lang=js"
export * from "./create_with_label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports